import { Button } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/components/Button.tsx";
import { EmptyState } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/components/EmptyState.tsx";
import { Link, type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import ShieldOff from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/shield-off.mjs";
import TriangleAlert from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/triangle-alert.mjs";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

import { ForbiddenError } from "../auth/guards";
import { translateError } from "../lib/errors";
import { PageHeading } from "./PageHeading";

/**
 * FR-FE01-21: the "no access" state (no login redirect). FE-14 FR-FE14-01: the admin area links
 * back to `/app/map`.
 */
export function NoAccess({ home = "/app" }: { home?: "/app" | "/portal" | "/app/map" }) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-[560px] p-4">
      <PageHeading title={t("noAccess.title")} className="sr-only">
        {t("noAccess.title")}
      </PageHeading>
      <EmptyState
        icon={ShieldOff}
        title={t("noAccess.title")}
        body={t("noAccess.body")}
        action={
          <Link
            to={home}
            className="inline-flex min-h-12 items-center font-semibold text-primary underline"
          >
            {t("noAccess.home")}
          </Link>
        }
      />
    </div>
  );
}

/** FR-FE01-06: translated error, retry, link to the area home. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  const router = useRouter();
  if (error instanceof ForbiddenError) return <NoAccess />;
  const home = router.state.location.pathname.startsWith("/portal") ? "/portal" : "/";
  return (
    <div className="mx-auto max-w-[560px] p-4">
      <PageHeading title={t("routeError.title")} className="sr-only">
        {t("routeError.title")}
      </PageHeading>
      <EmptyState
        icon={TriangleAlert}
        title={t("routeError.title")}
        body={translateError(error)}
        action={
          <div className="flex flex-wrap justify-center gap-3">
            <Button
              onClick={() => {
                reset();
                void router.invalidate();
              }}
            >
              {t("actions.retry")}
            </Button>
            <Link
              to={home}
              className="inline-flex min-h-12 items-center font-semibold text-primary underline"
            >
              {t("routeError.home")}
            </Link>
          </div>
        }
      />
    </div>
  );
}
